/**
 * A monotonic sequence shared by uploaded files and project-context items so the
 * composer can render every attachment in one insertion order (always append at
 * the end), regardless of which source it came from. Session-scoped — the order
 * only needs to be consistent within a composing session, not persisted.
 */
let sequence = 0;

export const nextAttachmentOrder = (): number => (sequence += 1);
